import React, { useState } from 'react'
import { toast } from 'react-toastify'

import XText from '../XText/XText'
import Button from '../Button/Button'
import TextField from '../TextField/TextField'

import { UKRAINE_PHONE_NUMBER_REG_EXP } from '../../constants/regexp.constants'

import { httpPost } from '../../services/http'

import './help-form.css'

const HelpForm = () => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [phoneFieldTouched, setPhoneFieldTouched] = useState(false)

  const addQuestion = () => {
    httpPost('question/add', {
      name,
      phone
    })
    .then(() => {
      toast.success('Ваш запит відправлено!')
      setName('')
      setPhone('')
    })
  }

  return (
    <section className='help-form'>
      <div className='help-form__title'>Потрібна допомога?</div>
      <div className='help-form__sub-title'>
        <span>Отримайте</span><XText>безкоштовну консультацію</XText>
      </div>
      <div className='flex-container'>
        <TextField
          placeholder="Ваше ім'я"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          type='phone'
          placeholder='Ваш телефон'
          value={phone}
          onChange={(e) => {
            setPhone(e.target.value)
            setPhoneFieldTouched(true)
          }}
          isInvalid={phoneFieldTouched && !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP)}
          errorText='Не валідний телефон'
        />
        <Button
          onClick={addQuestion}
          disabled={!name || !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP)}
        >
          Отримати консультацію
        </Button>
      </div>
    </section>
  )
}
export default HelpForm
